<template>
  <div class="relative">
    <el-input
      v-model="valueBackUp"
      :placeholder="placeholderBackup"
      :disabled="true"
    />
    <div class="absolute list">
      <div v-for="v in list" :key="v.id" :class="`card${valueBackUp === v.id ? ' checked' : ''}`" @click="handleClick(v)">
        <div class="title">{{  v.card_type_name }}
          <span class="card-id">No.{{v.id}}<span v-if="v.is_disable_column" class="danger-color bolder">（本课卡无法预约专栏）</span></span>
        </div>
        <div class="card-content">
          课卡名称：「<span class="success-color">{{ v.card_name }}</span>」；
          办卡门店：「{{v.store_name}}」；
          办卡日期：「{{ v.register_time | timeToYmd }}」
        </div>

        <div class="card-content">
          失效时间：「<span v-if="v.expire_time">{{ v.expire_time | timeToYmdHi }}</span><span v-else class="primary-color bolder">未开卡</span>」；
          <template v-if="v.is_number_limit">剩余次数：「<span class="success-color">{{ v.expire_number | toYuan }}</span> 次」；</template>
          有效天数：「{{ v.expire_days }} 天」；
        </div>

        <div class="card-content">
          适用范围：「<template v-if="v.store_names">仅限 <span class="success-color">v.store_names</span> 店使用</template><span v-else class="success-color">全国通用</span>」
          <template v-if="v.store_names">
            仅限{{ v.store_names }}店使用天数：「{{ v.store_limit_expire_days }} 天」；
          </template>
        </div>

        <div class="card-content">
          实际付款：「{{ v.actual_payment | toYuan }} 元」；
          付款方式：「{{ v.card_payment_mode_name }}」
        </div>

        <div class="card-content">
          付款备注：「{{ v.payment_remark }}」；
          课消：「{{ v.unit_price | toYuan }} 元」；
          <template v-if="v.you_zan_number">有赞券码：「{{ v.you_zan_number }}」</template>
        </div>
      </div>
      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { index } from '@/api/card';

export default {
  props: {
    value: [Number, String],
    studentId: [Number, String],
    cardChargeTypeId: [Number, String],
    cardTicketTypeId: [Number, String],
    placeholder: String,
    width: {
      type: String,
      default: '100%',
    },
    isWithoutInvoice: Boolean,
    isActualPaymentPositive: Boolean,
    courseColumnId: {
      type: Number,
      default: 0,
    },
    cardState: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    valueBackUp: '',
    placeholderBackup: '',
    inputValue: '',
    list: [],
    count: 0,
    page: 1,
    size: 3,
    pageSizes: [3],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackUp) return;
      this.valueBackUp = +value || '';
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp === (+this.value || '')) return;
      this.$emit('input', valueBackUp);
    },
    studentId(studentId) {
      if (studentId) {
        this.getList(studentId);
      } else {
        this.placeholderBackup = this.placeholder || '请选择学员后再选择课卡';
      }
    },
    list(list) {
      this.$emit('listLengthChange', list ? (list.length || 0) : 0);
    },
    cardTicketTypeId() {
      this.valueBackUp = '';
      this.getList(this.studentId);
    },
  },
  methods: {
    async getList(student_id) {
      if (!student_id) return;

      const { isError, data } = await index({
        student_ids: [student_id],
        card_charge_type_id: +this.cardChargeTypeId || 0,
        is_without_invoice: this.isWithoutInvoice ? 1 : 0,
        card_state: this.cardState,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
      this.placeholderBackup = '请选择课卡';
      this.$nextTick(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth',
        });
      });
    },
    handleClick(card) {
      if (!card.id) return;
      if (card.id === this.valueBackUp) return;
      if (this.isActualPaymentPositive && (!card.actual_payment || card.actual_payment <= 0)) {
        return this.$message.warning('请选择实际付款大于 0 的课卡！');
      }
      if (card.is_disable_column && this.courseColumnId > 0) {
        return this.$message.warning('该课卡不支持预约专栏课程，请选择其他有效课卡！');
      }

      this.valueBackUp = card.id;
      this.$emit('change', card);
    },
    handlePageChange() {
      this.getList(this.studentId);
    },
  },
  beforeMount() {
    this.valueBackUp = +this.value || '';
    this.placeholderBackup = this.placeholder || '请选择学员后再选择课卡';
    this.getList(this.studentId);
  },
};
</script>

<style src="./index.css" scoped/>
